export default __webpack_public_path__ + "static/media/expand_more_black_24dp.8a2212b7.svg";